import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/";

export function savePeriodStatus(fiscalPeriod) {
  return http.post(apiEndpoint + "period-status", fiscalPeriod);
}

export function updateAutoClosingPeriod(companyPreference) {
  return http.put(apiEndpoint + "auto-closing-period", companyPreference);
}

export function getExchangeRates() {
  return http.get(apiEndpoint + "exchange-rates");
}

export function saveExchangeRate(exchangeRate) {
  return httpSaveData("exchange-rate", exchangeRate);
}

export function deleteExchangeRate(exchangeRateID) {
  return http.delete(apiEndpoint + "exchange-rate/" + exchangeRateID);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}

export function getAssetStock() {
  return http.get(apiEndpoint + "asset-stock");
}

export function getAssetDetail(assetStockID = 0) {
  return http.get(apiEndpoint + "asset-detail/" + assetStockID);
}

export function saveAssetDirectInput(assetDirect) {
  return http.post(apiEndpoint + "asset-direct-input", assetDirect);
}

export function saveAssetDisposal(assetDisposal) {
  return http.post(apiEndpoint + "asset-disposal", assetDisposal);
}
